import { render } from "./CreatePlanDetailAndTaskForm.vue?vue&type=template&id=df0f10dc&scoped=true"
import script from "./CreatePlanDetailAndTaskForm.vue?vue&type=script&lang=js"
export * from "./CreatePlanDetailAndTaskForm.vue?vue&type=script&lang=js"

import "./CreatePlanDetailAndTaskForm.vue?vue&type=style&index=0&id=df0f10dc&scoped=true&lang=scss"

import exportComponent from "/voc/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-df0f10dc"]])

export default __exports__